import _toConsumableArray from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import { SubjectTopoligicalSorter } from "./SubjectTopoligicalSorter";
import { SubjectChangedColumnsComputer } from "./SubjectChangedColumnsComputer";
import { SubjectWithoutIdentifierError } from "../error/SubjectWithoutIdentifierError";
import { SubjectRemovedAndUpdatedError } from "../error/SubjectRemovedAndUpdatedError";
import { BroadcasterResult } from "../subscriber/BroadcasterResult";
import { NestedSetSubjectExecutor } from "./tree/NestedSetSubjectExecutor";
import { ClosureSubjectExecutor } from "./tree/ClosureSubjectExecutor";
import { MaterializedPathSubjectExecutor } from "./tree/MaterializedPathSubjectExecutor";
import { OrmUtils } from "../util/OrmUtils";
import { ObjectUtils } from "../util/ObjectUtils";
import { InstanceChecker } from "../util/InstanceChecker";
/**
 * Executes all database operations (inserts, updated, deletes) that must be executed
 * with given persistence subjects.
 */
export var SubjectExecutor = /*#__PURE__*/function () {
  // -------------------------------------------------------------------------
  // Constructor
  // -------------------------------------------------------------------------
  function SubjectExecutor(queryRunner, subjects, options) {
    _classCallCheck(this, SubjectExecutor);
    // -------------------------------------------------------------------------
    // Public Properties
    // -------------------------------------------------------------------------
    /**
     * Indicates if executor has any operations to execute (e.g. has insert / update / delete operations to be executed).
     */
    this.hasExecutableOperations = false;
    /**
     * Subjects that must be inserted.
     */
    this.insertSubjects = [];
    /**
     * Subjects that must be updated.
     */
    this.updateSubjects = [];
    /**
     * Subjects that must be removed.
     */
    this.removeSubjects = [];
    /**
     * Subjects that must be soft-removed.
     */
    this.softRemoveSubjects = [];
    /**
     * Subjects that must be recovered.
     */
    this.recoverSubjects = [];
    this.queryRunner = queryRunner;
    this.allSubjects = subjects;
    this.options = options;
    this.validate();
    this.recompute();
  }
  // -------------------------------------------------------------------------
  // Public Methods
  // -------------------------------------------------------------------------
  /**
   * Executes all operations over given array of subjects.
   * Executes queries using given query runner.
   */
  _createClass(SubjectExecutor, [{
    key: "execute",
    value: function () {
      var _execute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var broadcasterResult;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // console.time("SubjectExecutor.execute");
              // broadcast "before" events before we start insert / update / remove operations
              broadcasterResult = undefined;
              if (!(!this.options || this.options.listeners !== false)) {
                _context.next = 6;
                break;
              }
              // console.time(".broadcastBeforeEventsForAll");
              broadcasterResult = this.broadcastBeforeEventsForAll();
              if (!(broadcasterResult.promises.length > 0)) {
                _context.next = 6;
                break;
              }
              _context.next = 6;
              return Promise.all(broadcasterResult.promises);
            case 6:
              // since event listeners and subscribers can call save methods and/or trigger entity changes we need to recompute operational subjects
              // recompute only in the case if any listener or subscriber was really executed
              if (broadcasterResult && broadcasterResult.count > 0) {
                // console.time(".recompute");
                this.insertSubjects.forEach(function (subject) {
                  return subject.recompute();
                });
                this.updateSubjects.forEach(function (subject) {
                  return subject.recompute();
                });
                this.removeSubjects.forEach(function (subject) {
                  return subject.recompute();
                });
                this.softRemoveSubjects.forEach(function (subject) {
                  return subject.recompute();
                });
                this.recoverSubjects.forEach(function (subject) {
                  return subject.recompute();
                });
                this.recompute();
                // console.timeEnd(".recompute");
              }
              // make sure our insert subjects are sorted (using topological sorting) to make cascade inserts work properly
              // console.timeEnd("prepare");
              // execute all insert operations
              // console.time(".insertion");
              this.insertSubjects = new SubjectTopoligicalSorter(this.insertSubjects).sort("insert");
              _context.next = 10;
              return this.executeInsertOperations();
            case 10:
              // console.timeEnd(".insertion");
              // recompute update operations since insertion can create updation operations for the
              // properties it wasn't able to handle on its own (referenced columns)
              this.updateSubjects = this.allSubjects.filter(function (subject) {
                return subject.mustBeUpdated;
              });
              // execute update operations
              // console.time(".updation");
              _context.next = 13;
              return this.executeUpdateOperations();
            case 13:
              // console.timeEnd(".updation");
              // make sure our remove subjects are sorted (using topological sorting) when multiple entities are passed for the removal
              // console.time(".removal");
              this.removeSubjects = new SubjectTopoligicalSorter(this.removeSubjects).sort("delete");
              _context.next = 16;
              return this.executeRemoveOperations();
            case 16:
              // console.timeEnd(".removal");
              // recompute soft-remove operations
              this.softRemoveSubjects = this.allSubjects.filter(function (subject) {
                return subject.mustBeSoftRemoved;
              });
              // execute soft-remove operations
              _context.next = 19;
              return this.executeSoftRemoveOperations();
            case 19:
              // recompute recover operations
              this.recoverSubjects = this.allSubjects.filter(function (subject) {
                return subject.mustBeRecovered;
              });
              // execute recover operations
              _context.next = 22;
              return this.executeRecoverOperations();
            case 22:
              _context.next = 24;
              return this.updateSpecialColumnsInPersistedEntities();
            case 24:
              if (!(!this.options || this.options.listeners !== false)) {
                _context.next = 29;
                break;
              }
              // console.time(".broadcastAfterEventsForAll");
              broadcasterResult = this.broadcastAfterEventsForAll();
              if (!(broadcasterResult.promises.length > 0)) {
                _context.next = 29;
                break;
              }
              _context.next = 29;
              return Promise.all(broadcasterResult.promises);
            case 29:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function execute() {
        return _execute.apply(this, arguments);
      }
      return execute;
    }() // -------------------------------------------------------------------------
    // Protected Methods
    // -------------------------------------------------------------------------
    /**
     * Validates all given subjects.
     */
  }, {
    key: "validate",
    value: function validate() {
      this.allSubjects.forEach(function (subject) {
        if (subject.mustBeUpdated && subject.mustBeRemoved) throw new SubjectRemovedAndUpdatedError(subject);
      });
    }
    /**
     * Performs entity re-computations - finds changed columns, re-builds insert/update/remove subjects.
     */
  }, {
    key: "recompute",
    value: function recompute() {
      new SubjectChangedColumnsComputer().compute(this.allSubjects);
      this.insertSubjects = this.allSubjects.filter(function (subject) {
        return subject.mustBeInserted;
      });
      this.updateSubjects = this.allSubjects.filter(function (subject) {
        return subject.mustBeUpdated;
      });
      this.removeSubjects = this.allSubjects.filter(function (subject) {
        return subject.mustBeRemoved;
      });
      this.softRemoveSubjects = this.allSubjects.filter(function (subject) {
        return subject.mustBeSoftRemoved;
      });
      this.recoverSubjects = this.allSubjects.filter(function (subject) {
        return subject.mustBeRecovered;
      });
      this.hasExecutableOperations = this.insertSubjects.length > 0 || this.updateSubjects.length > 0 || this.removeSubjects.length > 0 || this.softRemoveSubjects.length > 0 || this.recoverSubjects.length > 0;
    }
    /**
     * Broadcasts "BEFORE_INSERT", "BEFORE_UPDATE", "BEFORE_REMOVE", "BEFORE_SOFT_REMOVE", "BEFORE_RECOVER" events for all given subjects.
     */
  }, {
    key: "broadcastBeforeEventsForAll",
    value: function broadcastBeforeEventsForAll() {
      var _this = this;
      var result = new BroadcasterResult();
      if (this.insertSubjects.length) this.insertSubjects.forEach(function (subject) {
        return _this.queryRunner.broadcaster.broadcastBeforeInsertEvent(result, subject.metadata, subject.entity);
      });
      if (this.updateSubjects.length) this.updateSubjects.forEach(function (subject) {
        return _this.queryRunner.broadcaster.broadcastBeforeUpdateEvent(result, subject.metadata, subject.entity, subject.databaseEntity, subject.diffColumns, subject.diffRelations);
      });
      if (this.removeSubjects.length) this.removeSubjects.forEach(function (subject) {
        return _this.queryRunner.broadcaster.broadcastBeforeRemoveEvent(result, subject.metadata, subject.entity, subject.databaseEntity);
      });
      if (this.softRemoveSubjects.length) this.softRemoveSubjects.forEach(function (subject) {
        return _this.queryRunner.broadcaster.broadcastBeforeSoftRemoveEvent(result, subject.metadata, subject.entity, subject.databaseEntity);
      });
      if (this.recoverSubjects.length) this.recoverSubjects.forEach(function (subject) {
        return _this.queryRunner.broadcaster.broadcastBeforeRecoverEvent(result, subject.metadata, subject.entity, subject.databaseEntity);
      });
      return result;
    }
    /**
     * Broadcasts "AFTER_INSERT", "AFTER_UPDATE", "AFTER_REMOVE", "AFTER_SOFT_REMOVE", "AFTER_RECOVER" events for all given subjects.
     * Returns void if there wasn't any listener or subscriber executed.
     * Note: this method has a performance-optimized code organization.
     */
  }, {
    key: "broadcastAfterEventsForAll",
    value: function broadcastAfterEventsForAll() {
      var _this2 = this;
      var result = new BroadcasterResult();
      if (this.insertSubjects.length) this.insertSubjects.forEach(function (subject) {
        return _this2.queryRunner.broadcaster.broadcastAfterInsertEvent(result, subject.metadata, subject.entity);
      });
      if (this.updateSubjects.length) this.updateSubjects.forEach(function (subject) {
        return _this2.queryRunner.broadcaster.broadcastAfterUpdateEvent(result, subject.metadata, subject.entity, subject.databaseEntity, subject.diffColumns, subject.diffRelations);
      });
      if (this.removeSubjects.length) this.removeSubjects.forEach(function (subject) {
        return _this2.queryRunner.broadcaster.broadcastAfterRemoveEvent(result, subject.metadata, subject.entity, subject.databaseEntity);
      });
      if (this.softRemoveSubjects.length) this.softRemoveSubjects.forEach(function (subject) {
        return _this2.queryRunner.broadcaster.broadcastAfterSoftRemoveEvent(result, subject.metadata, subject.entity, subject.databaseEntity);
      });
      if (this.recoverSubjects.length) this.recoverSubjects.forEach(function (subject) {
        return _this2.queryRunner.broadcaster.broadcastAfterRecoverEvent(result, subject.metadata, subject.entity, subject.databaseEntity);
      });
      return result;
    }
    /**
     * Executes insert operations.
     */
  }, {
    key: "executeInsertOperations",
    value: function () {
      var _executeInsertOperations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this3 = this;
        var _this$groupBulkSubjec, _this$groupBulkSubjec2, groupedInsertSubjects, groupedInsertSubjectKeys, _iterator, _step, _loop;
        return _regeneratorRuntime().wrap(function _callee2$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              // group insertion subjects to make bulk insertions
              _this$groupBulkSubjec = this.groupBulkSubjects(this.insertSubjects, "insert"), _this$groupBulkSubjec2 = _slicedToArray(_this$groupBulkSubjec, 2), groupedInsertSubjects = _this$groupBulkSubjec2[0], groupedInsertSubjectKeys = _this$groupBulkSubjec2[1]; // then we run insertion in the sequential order which is important since we have an ordered subjects
              _iterator = _createForOfIteratorHelper(groupedInsertSubjectKeys);
              _context4.prev = 2;
              _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
                var groupName, subjects, bulkInsertMaps, bulkInsertSubjects, singleInsertSubjects, insertResult, _insertResult, _iterator2, _step2, _loop2;
                return _regeneratorRuntime().wrap(function _loop$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      groupName = _step.value;
                      subjects = groupedInsertSubjects[groupName]; // we must separately insert entities which does not have any values to insert
                      // because its not possible to insert multiple entities with only default values in bulk
                      bulkInsertMaps = [];
                      bulkInsertSubjects = [];
                      singleInsertSubjects = [];
                      if (_this3.queryRunner.connection.driver.options.type === "mongodb") {
                        subjects.forEach(function (subject) {
                          if (subject.metadata.createDateColumn && subject.entity) {
                            subject.entity[subject.metadata.createDateColumn.databaseName] = new Date();
                          }
                          if (subject.metadata.updateDateColumn && subject.entity) {
                            subject.entity[subject.metadata.updateDateColumn.databaseName] = new Date();
                          }
                          subject.createValueSetAndPopChangeMap();
                          bulkInsertSubjects.push(subject);
                          bulkInsertMaps.push(subject.entity);
                        });
                      } else if (_this3.queryRunner.connection.driver.options.type === "oracle") {
                        subjects.forEach(function (subject) {
                          singleInsertSubjects.push(subject);
                        });
                      } else {
                        subjects.forEach(function (subject) {
                          // we do not insert in bulk in following cases:
                          // - when there is no values in insert (only defaults are inserted), since we cannot use DEFAULT VALUES expression for multiple inserted rows
                          // - when entity is a tree table, since tree tables require extra operation per each inserted row
                          // - when oracle is used, since oracle's bulk insertion is very bad
                          if (subject.changeMaps.length === 0 || subject.metadata.treeType || _this3.queryRunner.connection.driver.options.type === "oracle" || _this3.queryRunner.connection.driver.options.type === "sap") {
                            singleInsertSubjects.push(subject);
                          } else {
                            bulkInsertSubjects.push(subject);
                            bulkInsertMaps.push(subject.createValueSetAndPopChangeMap());
                          }
                        });
                      }
                      // for mongodb we have a bit different insertion logic
                      if (!InstanceChecker.isMongoEntityManager(_this3.queryRunner.manager)) {
                        _context3.next = 13;
                        break;
                      }
                      _context3.next = 9;
                      return _this3.queryRunner.manager.insert(subjects[0].metadata.target, bulkInsertMaps);
                    case 9:
                      insertResult = _context3.sent;
                      subjects.forEach(function (subject, index) {
                        subject.identifier = insertResult.identifiers[index];
                        subject.generatedMap = insertResult.generatedMaps[index];
                        subject.insertedValueSet = bulkInsertMaps[index];
                      });
                      _context3.next = 35;
                      break;
                    case 13:
                      if (!(bulkInsertMaps.length > 0)) {
                        _context3.next = 18;
                        break;
                      }
                      _context3.next = 16;
                      return _this3.queryRunner.manager.createQueryBuilder().insert().into(subjects[0].metadata.target).values(bulkInsertMaps).updateEntity(_this3.options && _this3.options.reload === false ? false : true).callListeners(false).execute();
                    case 16:
                      _insertResult = _context3.sent;
                      bulkInsertSubjects.forEach(function (subject, index) {
                        subject.identifier = _insertResult.identifiers[index];
                        subject.generatedMap = _insertResult.generatedMaps[index];
                        subject.insertedValueSet = bulkInsertMaps[index];
                      });
                    case 18:
                      if (!(singleInsertSubjects.length > 0)) {
                        _context3.next = 35;
                        break;
                      }
                      _iterator2 = _createForOfIteratorHelper(singleInsertSubjects);
                      _context3.prev = 20;
                      _loop2 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop2() {
                        var subject;
                        return _regeneratorRuntime().wrap(function _loop2$(_context2) {
                          while (1) switch (_context2.prev = _context2.next) {
                            case 0:
                              subject = _step2.value;
                              subject.insertedValueSet = subject.createValueSetAndPopChangeMap(); // important to have because query builder sets inserted values into it
                              // for nested set we execute additional queries
                              if (!(subject.metadata.treeType === "nested-set")) {
                                _context2.next = 5;
                                break;
                              }
                              _context2.next = 5;
                              return new NestedSetSubjectExecutor(_this3.queryRunner).insert(subject);
                            case 5:
                              _context2.next = 7;
                              return _this3.queryRunner.manager.createQueryBuilder().insert().into(subject.metadata.target).values(subject.insertedValueSet).updateEntity(_this3.options && _this3.options.reload === false ? false : true).callListeners(false).execute().then(function (insertResult) {
                                subject.identifier = insertResult.identifiers[0];
                                subject.generatedMap = insertResult.generatedMaps[0];
                              });
                            case 7:
                              if (!(subject.metadata.treeType === "closure-table")) {
                                _context2.next = 12;
                                break;
                              }
                              _context2.next = 10;
                              return new ClosureSubjectExecutor(_this3.queryRunner).insert(subject);
                            case 10:
                              _context2.next = 15;
                              break;
                            case 12:
                              if (!(subject.metadata.treeType === "materialized-path")) {
                                _context2.next = 15;
                                break;
                              }
                              _context2.next = 15;
                              return new MaterializedPathSubjectExecutor(_this3.queryRunner).insert(subject);
                            case 15:
                            case "end":
                              return _context2.stop();
                          }
                        }, _loop2);
                      });
                      _iterator2.s();
                    case 23:
                      if ((_step2 = _iterator2.n()).done) {
                        _context3.next = 27;
                        break;
                      }
                      return _context3.delegateYield(_loop2(), "t0", 25);
                    case 25:
                      _context3.next = 23;
                      break;
                    case 27:
                      _context3.next = 32;
                      break;
                    case 29:
                      _context3.prev = 29;
                      _context3.t1 = _context3["catch"](20);
                      _iterator2.e(_context3.t1);
                    case 32:
                      _context3.prev = 32;
                      _iterator2.f();
                      return _context3.finish(32);
                    case 35:
                      subjects.forEach(function (subject) {
                        if (subject.generatedMap) {
                          subject.metadata.columns.forEach(function (column) {
                            var value = column.getEntityValue(subject.generatedMap);
                            if (value !== undefined && value !== null) {
                              var preparedValue = _this3.queryRunner.connection.driver.prepareHydratedValue(value, column);
                              column.setEntityValue(subject.generatedMap, preparedValue);
                            }
                          });
                        }
                      });
                    case 36:
                    case "end":
                      return _context3.stop();
                  }
                }, _loop, null, [[20, 29, 32, 35]]);
              });
              _iterator.s();
            case 5:
              if ((_step = _iterator.n()).done) {
                _context4.next = 9;
                break;
              }
              return _context4.delegateYield(_loop(), "t0", 7);
            case 7:
              _context4.next = 5;
              break;
            case 9:
              _context4.next = 14;
              break;
            case 11:
              _context4.prev = 11;
              _context4.t1 = _context4["catch"](2);
              _iterator.e(_context4.t1);
            case 14:
              _context4.prev = 14;
              _iterator.f();
              return _context4.finish(14);
            case 17:
            case "end":
              return _context4.stop();
          }
        }, _callee2, this, [[2, 11, 14, 17]]);
      }));
      function executeInsertOperations() {
        return _executeInsertOperations.apply(this, arguments);
      }
      return executeInsertOperations;
    }()
    /**
     * Updates all given subjects in the database.
     */
  }, {
    key: "executeUpdateOperations",
    value: function () {
      var _executeUpdateOperations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this4 = this;
        var updateSubject, nestedSetSubjects, remainingSubjects, _iterator3, _step3, subject, nestedSetPromise;
        return _regeneratorRuntime().wrap(function _callee5$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              updateSubject = /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(subject) {
                  var partialEntity, manager, updateMap, updateQueryBuilder, updateResult, updateGeneratedMap;
                  return _regeneratorRuntime().wrap(function _callee3$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        if (subject.identifier) {
                          _context5.next = 2;
                          break;
                        }
                        throw new SubjectWithoutIdentifierError(subject);
                      case 2:
                        if (!InstanceChecker.isMongoEntityManager(_this4.queryRunner.manager)) {
                          _context5.next = 12;
                          break;
                        }
                        partialEntity = _this4.cloneMongoSubjectEntity(subject);
                        if (subject.metadata.objectIdColumn && subject.metadata.objectIdColumn.propertyName) {
                          delete partialEntity[subject.metadata.objectIdColumn.propertyName];
                        }
                        if (subject.metadata.createDateColumn && subject.metadata.createDateColumn.propertyName) {
                          delete partialEntity[subject.metadata.createDateColumn.propertyName];
                        }
                        if (subject.metadata.updateDateColumn && subject.metadata.updateDateColumn.propertyName) {
                          partialEntity[subject.metadata.updateDateColumn.propertyName] = new Date();
                        }
                        manager = _this4.queryRunner.manager;
                        _context5.next = 10;
                        return manager.update(subject.metadata.target, subject.identifier, partialEntity);
                      case 10:
                        _context5.next = 32;
                        break;
                      case 12:
                        updateMap = subject.createValueSetAndPopChangeMap(); // for tree tables we execute additional queries
                        _context5.t0 = subject.metadata.treeType;
                        _context5.next = _context5.t0 === "nested-set" ? 16 : _context5.t0 === "closure-table" ? 19 : _context5.t0 === "materialized-path" ? 22 : 25;
                        break;
                      case 16:
                        _context5.next = 18;
                        return new NestedSetSubjectExecutor(_this4.queryRunner).update(subject);
                      case 18:
                        return _context5.abrupt("break", 25);
                      case 19:
                        _context5.next = 21;
                        return new ClosureSubjectExecutor(_this4.queryRunner).update(subject);
                      case 21:
                        return _context5.abrupt("break", 25);
                      case 22:
                        _context5.next = 24;
                        return new MaterializedPathSubjectExecutor(_this4.queryRunner).update(subject);
                      case 24:
                        return _context5.abrupt("break", 25);
                      case 25:
                        // here we execute our updation query
                        // we need to enable entity updation because we update a subject identifier
                        // which is not same object as our entity that's why we don't need to worry about our entity to get dirty
                        // also, we disable listeners because we call them on our own in persistence layer
                        updateQueryBuilder = _this4.queryRunner.manager.createQueryBuilder().update(subject.metadata.target).set(updateMap).updateEntity(_this4.options && _this4.options.reload === false ? false : true).callListeners(false);
                        if (subject.entity) {
                          updateQueryBuilder.whereEntity(subject.identifier);
                        } else {
                          // in this case identifier is just conditions object to update by
                          updateQueryBuilder.where(subject.identifier);
                        }
                        _context5.next = 29;
                        return updateQueryBuilder.execute();
                      case 29:
                        updateResult = _context5.sent;
                        updateGeneratedMap = updateResult.generatedMaps[0];
                        if (updateGeneratedMap) {
                          subject.metadata.columns.forEach(function (column) {
                            var value = column.getEntityValue(updateGeneratedMap);
                            if (value !== undefined && value !== null) {
                              var preparedValue = _this4.queryRunner.connection.driver.prepareHydratedValue(value, column);
                              column.setEntityValue(updateGeneratedMap, preparedValue);
                            }
                          });
                          if (!subject.generatedMap) {
                            subject.generatedMap = {};
                          }
                          Object.assign(subject.generatedMap, updateGeneratedMap);
                        }
                      case 32:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee3);
                }));
                return function updateSubject(_x) {
                  return _ref.apply(this, arguments);
                };
              }(); // Nested sets need to be updated one by one
              // Split array in two, one with nested set subjects and the other with the remaining subjects
              nestedSetSubjects = [];
              remainingSubjects = [];
              _iterator3 = _createForOfIteratorHelper(this.updateSubjects);
              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  subject = _step3.value;
                  if (subject.metadata.treeType === "nested-set") {
                    nestedSetSubjects.push(subject);
                  } else {
                    remainingSubjects.push(subject);
                  }
                }
                // Run nested set updates one by one
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
              nestedSetPromise = new Promise( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(ok, fail) {
                  var _i, _nestedSetSubjects, subject;
                  return _regeneratorRuntime().wrap(function _callee4$(_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        _i = 0, _nestedSetSubjects = nestedSetSubjects;
                      case 1:
                        if (!(_i < _nestedSetSubjects.length)) {
                          _context6.next = 14;
                          break;
                        }
                        subject = _nestedSetSubjects[_i];
                        _context6.prev = 3;
                        _context6.next = 6;
                        return updateSubject(subject);
                      case 6:
                        _context6.next = 11;
                        break;
                      case 8:
                        _context6.prev = 8;
                        _context6.t0 = _context6["catch"](3);
                        fail(_context6.t0);
                      case 11:
                        _i++;
                        _context6.next = 1;
                        break;
                      case 14:
                        ok();
                      case 15:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee4, null, [[3, 8]]);
                }));
                return function (_x2, _x3) {
                  return _ref2.apply(this, arguments);
                };
              }()); // Run all remaining subjects in parallel
              _context7.next = 8;
              return Promise.all([].concat(_toConsumableArray(remainingSubjects.map(updateSubject)), [nestedSetPromise]));
            case 8:
            case "end":
              return _context7.stop();
          }
        }, _callee5, this);
      }));
      function executeUpdateOperations() {
        return _executeUpdateOperations.apply(this, arguments);
      }
      return executeUpdateOperations;
    }()
    /**
     * Removes all given subjects from the database.
     *
     * todo: we need to apply topological sort here as well
     */
  }, {
    key: "executeRemoveOperations",
    value: function () {
      var _executeRemoveOperations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this$groupBulkSubjec3, _this$groupBulkSubjec4, groupedRemoveSubjects, groupedRemoveSubjectKeys, _iterator4, _step4, groupName, subjects, deleteMaps, manager;
        return _regeneratorRuntime().wrap(function _callee6$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              // group insertion subjects to make bulk insertions
              _this$groupBulkSubjec3 = this.groupBulkSubjects(this.removeSubjects, "delete"), _this$groupBulkSubjec4 = _slicedToArray(_this$groupBulkSubjec3, 2), groupedRemoveSubjects = _this$groupBulkSubjec4[0], groupedRemoveSubjectKeys = _this$groupBulkSubjec4[1];
              _iterator4 = _createForOfIteratorHelper(groupedRemoveSubjectKeys);
              _context8.prev = 2;
              _iterator4.s();
            case 4:
              if ((_step4 = _iterator4.n()).done) {
                _context8.next = 27;
                break;
              }
              groupName = _step4.value;
              subjects = groupedRemoveSubjects[groupName];
              deleteMaps = subjects.map(function (subject) {
                if (!subject.identifier) throw new SubjectWithoutIdentifierError(subject);
                return subject.identifier;
              }); // for mongodb we have a bit different updation logic
              if (!InstanceChecker.isMongoEntityManager(this.queryRunner.manager)) {
                _context8.next = 14;
                break;
              }
              manager = this.queryRunner.manager;
              _context8.next = 12;
              return manager.delete(subjects[0].metadata.target, deleteMaps);
            case 12:
              _context8.next = 25;
              break;
            case 14:
              _context8.t0 = subjects[0].metadata.treeType;
              _context8.next = _context8.t0 === "nested-set" ? 17 : _context8.t0 === "closure-table" ? 20 : 23;
              break;
            case 17:
              _context8.next = 19;
              return new NestedSetSubjectExecutor(this.queryRunner).remove(subjects);
            case 19:
              return _context8.abrupt("break", 23);
            case 20:
              _context8.next = 22;
              return new ClosureSubjectExecutor(this.queryRunner).remove(subjects);
            case 22:
              return _context8.abrupt("break", 23);
            case 23:
              _context8.next = 25;
              return this.queryRunner.manager.createQueryBuilder().delete().from(subjects[0].metadata.target).where(deleteMaps).callListeners(false).execute();
            case 25:
              _context8.next = 4;
              break;
            case 27:
              _context8.next = 32;
              break;
            case 29:
              _context8.prev = 29;
              _context8.t1 = _context8["catch"](2);
              _iterator4.e(_context8.t1);
            case 32:
              _context8.prev = 32;
              _iterator4.f();
              return _context8.finish(32);
            case 35:
            case "end":
              return _context8.stop();
          }
        }, _callee6, this, [[2, 29, 32, 35]]);
      }));
      function executeRemoveOperations() {
        return _executeRemoveOperations.apply(this, arguments);
      }
      return executeRemoveOperations;
    }()
  }, {
    key: "cloneMongoSubjectEntity",
    value: function cloneMongoSubjectEntity(subject) {
      var target = {};
      if (subject.entity) {
        var _iterator5 = _createForOfIteratorHelper(subject.metadata.columns),
          _step5;
        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var column = _step5.value;
            OrmUtils.mergeDeep(target, column.getEntityValueMap(subject.entity));
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }
      return target;
    }
    /**
     * Soft-removes all given subjects in the database.
     */
  }, {
    key: "executeSoftRemoveOperations",
    value: function () {
      var _executeSoftRemoveOperations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var _this5 = this;
        return _regeneratorRuntime().wrap(function _callee8$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return Promise.all(this.softRemoveSubjects.map( /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(subject) {
                  var updateResult, partialEntity, manager, softDeleteQueryBuilder;
                  return _regeneratorRuntime().wrap(function _callee7$(_context9) {
                    while (1) switch (_context9.prev = _context9.next) {
                      case 0:
                        if (subject.identifier) {
                          _context9.next = 2;
                          break;
                        }
                        throw new SubjectWithoutIdentifierError(subject);
                      case 2:
                        if (!InstanceChecker.isMongoEntityManager(_this5.queryRunner.manager)) {
                          _context9.next = 14;
                          break;
                        }
                        partialEntity = _this5.cloneMongoSubjectEntity(subject);
                        if (subject.metadata.objectIdColumn && subject.metadata.objectIdColumn.propertyName) {
                          delete partialEntity[subject.metadata.objectIdColumn.propertyName];
                        }
                        if (subject.metadata.createDateColumn && subject.metadata.createDateColumn.propertyName) {
                          delete partialEntity[subject.metadata.createDateColumn.propertyName];
                        }
                        if (subject.metadata.updateDateColumn && subject.metadata.updateDateColumn.propertyName) {
                          partialEntity[subject.metadata.updateDateColumn.propertyName] = new Date();
                        }
                        if (subject.metadata.deleteDateColumn && subject.metadata.deleteDateColumn.propertyName) {
                          partialEntity[subject.metadata.deleteDateColumn.propertyName] = new Date();
                        }
                        manager = _this5.queryRunner.manager;
                        _context9.next = 11;
                        return manager.update(subject.metadata.target, subject.identifier, partialEntity);
                      case 11:
                        updateResult = _context9.sent;
                        _context9.next = 19;
                        break;
                      case 14:
                        // here we execute our soft-deletion query
                        // we need to enable entity soft-deletion because we update a subject identifier
                        // which is not same object as our entity that's why we don't need to worry about our entity to get dirty
                        // also, we disable listeners because we call them on our own in persistence layer
                        softDeleteQueryBuilder = _this5.queryRunner.manager.createQueryBuilder().softDelete().from(subject.metadata.target).updateEntity(_this5.options && _this5.options.reload === false ? false : true).callListeners(false);
                        if (subject.entity) {
                          softDeleteQueryBuilder.whereEntity(subject.identifier);
                        } else {
                          // in this case identifier is just conditions object to update by
                          softDeleteQueryBuilder.where(subject.identifier);
                        }
                        _context9.next = 18;
                        return softDeleteQueryBuilder.execute();
                      case 18:
                        updateResult = _context9.sent;
                      case 19:
                        subject.generatedMap = updateResult.generatedMaps[0];
                        if (subject.generatedMap) {
                          subject.metadata.columns.forEach(function (column) {
                            var value = column.getEntityValue(subject.generatedMap);
                            if (value !== undefined && value !== null) {
                              var preparedValue = _this5.queryRunner.connection.driver.prepareHydratedValue(value, column);
                              column.setEntityValue(subject.generatedMap, preparedValue);
                            }
                          });
                        }
                        // experiments, remove probably, need to implement tree tables children removal
                        // if (subject.updatedRelationMaps.length > 0) {
                        //     await Promise.all(subject.updatedRelationMaps.map(async updatedRelation => {
                        //         if (!updatedRelation.relation.isTreeParent) return;
                        //         if (!updatedRelation.value !== null) return;
                        //
                        //         if (subject.metadata.treeType === "closure-table") {
                        //             await new ClosureSubjectExecutor(this.queryRunner).deleteChildrenOf(subject);
                        //         }
                        //     }));
                        // }
                      case 21:
                      case "end":
                        return _context9.stop();
                    }
                  }, _callee7);
                }));
                return function (_x4) {
                  return _ref3.apply(this, arguments);
                };
              }()));
            case 2:
            case "end":
              return _context10.stop();
          }
        }, _callee8, this);
      }));
      function executeSoftRemoveOperations() {
        return _executeSoftRemoveOperations.apply(this, arguments);
      }
      return executeSoftRemoveOperations;
    }()
    /**
     * Recovers all given subjects in the database.
     */
  }, {
    key: "executeRecoverOperations",
    value: function () {
      var _executeRecoverOperations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var _this6 = this;
        return _regeneratorRuntime().wrap(function _callee10$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return Promise.all(this.recoverSubjects.map( /*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(subject) {
                  var updateResult, partialEntity, manager, softDeleteQueryBuilder;
                  return _regeneratorRuntime().wrap(function _callee9$(_context11) {
                    while (1) switch (_context11.prev = _context11.next) {
                      case 0:
                        if (subject.identifier) {
                          _context11.next = 2;
                          break;
                        }
                        throw new SubjectWithoutIdentifierError(subject);
                      case 2:
                        if (!InstanceChecker.isMongoEntityManager(_this6.queryRunner.manager)) {
                          _context11.next = 14;
                          break;
                        }
                        partialEntity = _this6.cloneMongoSubjectEntity(subject);
                        if (subject.metadata.objectIdColumn && subject.metadata.objectIdColumn.propertyName) {
                          delete partialEntity[subject.metadata.objectIdColumn.propertyName];
                        }
                        if (subject.metadata.createDateColumn && subject.metadata.createDateColumn.propertyName) {
                          delete partialEntity[subject.metadata.createDateColumn.propertyName];
                        }
                        if (subject.metadata.updateDateColumn && subject.metadata.updateDateColumn.propertyName) {
                          partialEntity[subject.metadata.updateDateColumn.propertyName] = new Date();
                        }
                        if (subject.metadata.deleteDateColumn && subject.metadata.deleteDateColumn.propertyName) {
                          partialEntity[subject.metadata.deleteDateColumn.propertyName] = null;
                        }
                        manager = _this6.queryRunner.manager;
                        _context11.next = 11;
                        return manager.update(subject.metadata.target, subject.identifier, partialEntity);
                      case 11:
                        updateResult = _context11.sent;
                        _context11.next = 19;
                        break;
                      case 14:
                        // here we execute our restory query
                        // we need to enable entity restory because we update a subject identifier
                        // which is not same object as our entity that's why we don't need to worry about our entity to get dirty
                        // also, we disable listeners because we call them on our own in persistence layer
                        softDeleteQueryBuilder = _this6.queryRunner.manager.createQueryBuilder().restore().from(subject.metadata.target).updateEntity(_this6.options && _this6.options.reload === false ? false : true).callListeners(false);
                        if (subject.entity) {
                          softDeleteQueryBuilder.whereEntity(subject.identifier);
                        } else {
                          // in this case identifier is just conditions object to update by
                          softDeleteQueryBuilder.where(subject.identifier);
                        }
                        _context11.next = 18;
                        return softDeleteQueryBuilder.execute();
                      case 18:
                        updateResult = _context11.sent;
                      case 19:
                        subject.generatedMap = updateResult.generatedMaps[0];
                        if (subject.generatedMap) {
                          subject.metadata.columns.forEach(function (column) {
                            var value = column.getEntityValue(subject.generatedMap);
                            if (value !== undefined && value !== null) {
                              var preparedValue = _this6.queryRunner.connection.driver.prepareHydratedValue(value, column);
                              column.setEntityValue(subject.generatedMap, preparedValue);
                            }
                          });
                        }
                        // experiments, remove probably, need to implement tree tables children removal
                        // if (subject.updatedRelationMaps.length > 0) {
                        //     await Promise.all(subject.updatedRelationMaps.map(async updatedRelation => {
                        //         if (!updatedRelation.relation.isTreeParent) return;
                        //         if (!updatedRelation.value !== null) return;
                        //
                        //         if (subject.metadata.treeType === "closure-table") {
                        //             await new ClosureSubjectExecutor(this.queryRunner).deleteChildrenOf(subject);
                        //         }
                        //     }));
                        // }
                      case 21:
                      case "end":
                        return _context11.stop();
                    }
                  }, _callee9);
                }));
                return function (_x5) {
                  return _ref4.apply(this, arguments);
                };
              }()));
            case 2:
            case "end":
              return _context12.stop();
          }
        }, _callee10, this);
      }));
      function executeRecoverOperations() {
        return _executeRecoverOperations.apply(this, arguments);
      }
      return executeRecoverOperations;
    }()
    /**
     * Updates all special columns of the saving entities (create date, update date, version, etc.).
     * Also updates nullable columns and columns with default values.
     */
  }, {
    key: "updateSpecialColumnsInPersistedEntities",
    value: function updateSpecialColumnsInPersistedEntities() {
      var _this7 = this;
      // update inserted entity properties
      if (this.insertSubjects.length) this.updateSpecialColumnsInInsertedAndUpdatedEntities(this.insertSubjects);
      // update updated entity properties
      if (this.updateSubjects.length) this.updateSpecialColumnsInInsertedAndUpdatedEntities(this.updateSubjects);
      // update soft-removed entity properties
      if (this.softRemoveSubjects.length) this.updateSpecialColumnsInInsertedAndUpdatedEntities(this.softRemoveSubjects);
      // update recovered entity properties
      if (this.recoverSubjects.length) this.updateSpecialColumnsInInsertedAndUpdatedEntities(this.recoverSubjects);
      // remove ids from the entities that were removed
      if (this.removeSubjects.length) {
        this.removeSubjects.forEach(function (subject) {
          if (!subject.entity) return;
          subject.metadata.primaryColumns.forEach(function (primaryColumn) {
            primaryColumn.setEntityValue(subject.entity, undefined);
          });
        });
      }
      // other post-persist updations
      this.allSubjects.forEach(function (subject) {
        if (!subject.entity) return;
        subject.metadata.relationIds.forEach(function (relationId) {
          relationId.setValue(subject.entity);
        });
        // mongo _id remove
        if (InstanceChecker.isMongoEntityManager(_this7.queryRunner.manager)) {
          if (subject.metadata.objectIdColumn && subject.metadata.objectIdColumn.databaseName && subject.metadata.objectIdColumn.databaseName !== subject.metadata.objectIdColumn.propertyName) {
            delete subject.entity[subject.metadata.objectIdColumn.databaseName];
          }
        }
      });
    }
    /**
     * Updates all special columns of the saving entities (create date, update date, version, etc.).
     * Also updates nullable columns and columns with default values.
     */
  }, {
    key: "updateSpecialColumnsInInsertedAndUpdatedEntities",
    value: function updateSpecialColumnsInInsertedAndUpdatedEntities(subjects) {
      var _this8 = this;
      subjects.forEach(function (subject) {
        if (!subject.entity) return;
        // set values to "null" for nullable columns that did not have values
        subject.metadata.columns.forEach(function (column) {
          // if table inheritance is used make sure this column is not child's column
          if (subject.metadata.childEntityMetadatas.length > 0 && subject.metadata.childEntityMetadatas.map(function (metadata) {
            return metadata.target;
          }).indexOf(column.target) !== -1) return;
          // entities does not have virtual columns
          if (column.isVirtual) return;
          // update nullable columns
          if (column.isNullable) {
            var columnValue = column.getEntityValue(subject.entity);
            if (columnValue === undefined) column.setEntityValue(subject.entity, null);
          }
          // update relational columns
          if (subject.updatedRelationMaps.length > 0) {
            subject.updatedRelationMaps.forEach(function (updatedRelationMap) {
              updatedRelationMap.relation.joinColumns.forEach(function (column) {
                if (column.isVirtual === true) return;
                column.setEntityValue(subject.entity, ObjectUtils.isObject(updatedRelationMap.value) ? column.referencedColumn.getEntityValue(updatedRelationMap.value) : updatedRelationMap.value);
              });
            });
          }
        });
        // merge into entity all generated values returned by a database
        if (subject.generatedMap) _this8.queryRunner.manager.merge(subject.metadata.target, subject.entity, subject.generatedMap);
      });
    }
    /**
     * Groups subjects by metadata names (by tables) to make bulk insertions and deletions possible.
     * However there are some limitations with bulk insertions of data into tables with generated (increment) columns
     * in some drivers. Some drivers like mysql and sqlite does not support returning multiple generated columns
     * after insertion and can only return a single generated column value, that's why its not possible to do bulk insertion,
     * because it breaks insertion result's generatedMap and leads to problems when this subject is used in other subjects saves.
     * That's why we only support bulking in junction tables for those drivers.
     *
     * Other drivers like postgres and sql server support RETURNING / OUTPUT statement which allows to return generated
     * id for each inserted row, that's why bulk insertion is not limited to junction tables in there.
     */
  }, {
    key: "groupBulkSubjects",
    value: function groupBulkSubjects(subjects, type) {
      var group = {};
      var keys = [];
      var hasReturningDependColumns = subjects.some(function (subject) {
        return subject.metadata.getInsertionReturningColumns().length > 0;
      });
      var groupingAllowed = type === "delete" || this.queryRunner.connection.driver.isReturningSqlSupported("insert") || hasReturningDependColumns === false;
      subjects.forEach(function (subject, index) {
        var key = groupingAllowed || subject.metadata.isJunction ? subject.metadata.name : subject.metadata.name + "_" + index;
        if (!group[key]) {
          group[key] = [subject];
          keys.push(key);
        } else {
          group[key].push(subject);
        }
      });
      return [group, keys];
    }
  }]);
  return SubjectExecutor;
}();